import React, {Component} from 'react';
import UserGroupAttributesCell from "./UserGroupAttributesCell";
import {PropTypes} from 'prop-types';
import UserGroupAttributesEnum from "./UserGroupAttributesEnum";
import * as messageConstants from '../../../shared/messages';

class UserGroupAttributesRow extends Component {

  static propTypes = {
    userGroupAttribute: PropTypes.any,
    onUserGroupAttributesTableUpdate: PropTypes.func,
    onRowDel: PropTypes.func,
    rowIndex: PropTypes.any,
  }
  handleOnUserGroupAttributesTableUpdate = (e) => {
    this.props.onUserGroupAttributesTableUpdate(e);
  }

  onDelEvent() {
    this.props.onRowDel(this.props.userGroupAttribute);
  }

  render() {
    return (
        <tr>
          <td className="pb-12">
            <UserGroupAttributesCell
                className="attributes-name-input form-control attributes-input"
                onUserGroupAttributesTableUpdate={this.handleOnUserGroupAttributesTableUpdate}
                cellData={{
                  type: "userGroupAttributeName",
                  value: this.props.userGroupAttribute.userGroupAttributeName,
                  id: this.props.id,
                  placeholder: messageConstants.ATTRIBUTE_NAME
                }}/>
          </td>
          <td className="pl-12 pb-12">
            <UserGroupAttributesEnum
                onUserGroupAttributesTableUpdate={this.handleOnUserGroupAttributesTableUpdate}
                displayUserGroupAttributes={this.props.displayUserGroupAttributes}
                cellData={{
                  type: "idpGroupAttributeFilterEnum",
                  value: this.props.userGroupAttribute.idpGroupAttributeFilterEnum,
                  id: this.props.id
                }}/>
          </td>
          <td className="pl-12 pb-12">
             <UserGroupAttributesCell
                className="attributes-custom-value-input form-control attributes-input"
                onUserGroupAttributesTableUpdate={this.handleOnUserGroupAttributesTableUpdate}
                cellData={{
                  type: "idpGroupAttributeFilterValue",
                  value: this.props.userGroupAttribute.idpGroupAttributeFilterValue,
                  id: this.props.id,
                  placeholder: messageConstants.GROUP_NAME_MATCHING_PATTERN
                }}/>
          </td>
          <td className="pl-12">
            <div className="remove-attribute-col">
              <button type="button" onClick={this.onDelEvent.bind(this)}
                      className="attr-button dell-button">
                <span className="fa fa-minus btn-circle btn-minus"/>
                <span
                    className="attr-button-label">{messageConstants.BUTTON_REMOVE_ATTRIBUTE}
                </span>
              </button>
            </div>
          </td>
        </tr>
    );
  }

}

export default UserGroupAttributesRow;